/* eslint-disable camelcase */
import React, { createContext, useContext, useState } from 'react'
import api from '../services/api'

const AuthContext = createContext()

export const useAuth = () => {
  return useContext(AuthContext)
}

export const AuthProvider = ({ children }) => {
  const token = localStorage.getItem('token')

  const [isLoggedIn, setIsLoggedIn] = useState(!!token)

  const [loginRejected, setLoginRejected] = useState<boolean>(false)

  const validateToken = async (): Promise<boolean> => {
    return new Promise((resolve, reject) => {
      if (!token) resolve(false)

      api
        .post('/v1/user/authenticate/verify')
        .then(async (response) => {
          console.log('Token verify: ', response.data)
          setIsLoggedIn(true)
          resolve(true)
        })
        .catch((err) => {
          console.log(err)
          resolve(false)
        })
    })
  }

  const signIn = ({ login, password }) => {
    return new Promise((resolve, reject) => {
      api
        .post('/v1/user/authenticate/login', {
          login,
          password,
        })
        .then((response) => {
          const data = response.data
          console.log('ESSSEE', data)
          if (
            // data.user.role === 'SEGURANCA' ||
            data.user.role === 'ADMINISTRADOR'
          ) {
            localStorage.setItem('token', data.token)
            localStorage.setItem('id_user', data.user.id)
            localStorage.setItem('id_employee', data.user.Employee[0].id)
            localStorage.setItem('role', data.user.role)
            setIsLoggedIn(true)

            resolve(response)
          }

          console.log('Usuário não permitido')
          setLoginRejected((prev) => !prev)

          resolve(false)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  }

  const logout = () => {
    return new Promise((resolve, reject) => {
      api
        .post('/v1/user/authenticate/logout')
        .then(() => {
          localStorage.clear()
          setIsLoggedIn(false)
          setLoginRejected(false)
        })
        .catch((err) => {
          console.log('error', err)
        })
    })
  }

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        signIn,
        logout,
        validateToken,
        loginRejected,
        setLoginRejected,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
